import { useEffect, useRef } from "react";

export function useIdleTimeout(onTimeout, timeout) {
  const timerRef = useRef(null);
  const storageKey = "lastActivity";
  useEffect(() => {
    if (!timeout) return; // si aún no está definido, no hago nada

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      //timerRef.current = setTimeout(onTimeout, timeout  * (1000 * 60));
      timerRef.current = setTimeout(checkTimeout, timeout * (1000 * 60));
      localStorage.setItem(storageKey, Date.now().toString());
    };

    const checkTimeout = () => {
      const last = parseInt(localStorage.getItem(storageKey) || "0", 10);
      if (Date.now() - last >= timeout * (1000 * 60)) {
        onTimeout();
      } else {
        resetTimer(); // otra pestaña estuvo activa, reiniciamos
      }
    };

    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach(event => window.addEventListener(event, resetTimer));

    const syncActivity = () => {
      resetTimer();
    };
    window.addEventListener("storage", syncActivity);

    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, resetTimer));
      window.removeEventListener("storage", syncActivity);
    };
  }, [onTimeout, timeout]);
}
